import Box from '@mui/material/Box';
import type { FC } from 'react';

import { FAQContent } from '~/components/molecules/FAQContent';
import { PAGE_CONTENT_MAX_WIDTH_NARROW } from '~/constants';
import type { FaqListProps } from '~/types/sanity/components';

export const FAQList: FC<Omit<FaqListProps, '_key' | '_type'>> = (props) => (
  <Box
    sx={{
      px: { xs: 2, md: 5 },
      py: { xs: 3, md: 4 },
      maxWidth: PAGE_CONTENT_MAX_WIDTH_NARROW,
      mx: 'auto',
    }}
  >
    <FAQContent {...props} />
  </Box>
);
